import * as am5 from '@amcharts/amcharts5';
import { getChartColorAtIndex } from '@skudo/helpers/charts.helpers';
import {
  AXIS_TYPE,
  CHART_LAYOUT_TYPE,
  LineSerieOptions,
  LineSeriesCursorOptions,
  LineSeriesRenderOptions,
} from 'emma-common-ts/skudo';

export const getLayoutByType = (type: CHART_LAYOUT_TYPE, root: am5.Root): am5.Layout => {
  switch (type) {
    case CHART_LAYOUT_TYPE.GRID:
      return root.gridLayout;
    case CHART_LAYOUT_TYPE.HORIZONTAL:
      return root.horizontalLayout;
  }
  return root.verticalLayout;
};

export const getDefaultCursor = (): LineSeriesCursorOptions => {
  return {
    snapToAxis: AXIS_TYPE.Y,
    lines: [
      {
        axisType: AXIS_TYPE.X,
        grid: {
          visible: true,
          strokeColor: 0xf3a229,
          strokeWidth: 2,
          strokeDasharray: [],
        },
      },
      {
        axisType: AXIS_TYPE.Y,
        grid: {
          visible: false,
        },
      },
    ],
  };
};

export const getDefaultAxisRenderer = (): LineSeriesRenderOptions[] => {
  return [
    {
      axisType: AXIS_TYPE.X,
      labels: {
        color: 0x9198a7,
        fontSize: '0.9rem',
        paddingTop: 30,
      },
      grid: {
        visible: false,
      },
    },
    {
      axisType: AXIS_TYPE.Y,
      labels: {
        color: 0x6f747c,
        fontSize: '0.9rem',
      },
      grid: {
        visible: true,
        color: 0x9198a7,
        strokeWidth: 1,
      },
    },
  ];
};

export const getDefaultSerieOptionsAtIndex = (index: number): LineSerieOptions => {
  const serieColor = getChartColorAtIndex(index);
  return {
    color: serieColor,
    strokeColor: serieColor,
    showLegend: true,
    tooltip: {
      label: {
        text: '[bold]{valueY} [bold]{name}[/]',
      },
      fillFromSprite: true,
      autoTextColor: true,
      strokeFromSprite: true,
    },
    fills: {
      opacity: 1,
      visible: true,
      linearGradient: {
        stops: [
          {
            opacity: 0.5,
          },
          {
            opacity: 0,
          },
        ],
        rotation: 90,
      },
    },
    strokes: {
      strokeWidth: 5,
    },
  };
};
